import React from "react";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";
import { COLUMN_PATHS } from "@icarius-pages/modulesAndMenus/columnDef";
import MenuItemWithIcon from "@icarius-common/MenuItemWithIcon";
import ExclusionsFormDialog from "./exclusionsFormDialog";
import DuplicateExclusionsFormDialog from "./duplicateExclusionsFormDialog";
import useExclusions from "./useExclusions";

const Exclusions = () => {

  const {
    isLoading,
    exclusions,
    moduleList,
    tree,
    collaboratorsList,
    resources,
    state,
    handlers,
  } = useExclusions();

  const createButton = () => (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={() => handlers.handleOpenCreateForm()}
      type={"add"}
    />
  )

  const editButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenUpdateForm(gridRef)}
      type={"edit"}
    />
  )

  const deleteButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteDialog(gridRef)}
      type={"delete"}
    />
  )

  const duplicateButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("duplicate")}
      onClick={() => handlers.handleOpenDuplicateForm(gridRef)}
      type={"duplicate"}
    />
  )

  const helpItems = resources?.map((resource, index) => {
    return (
      <MenuItemWithIcon key={index} value={resource.path} text={resource.name} type={"file"} />
    )
  })

  return (
    <CommonPage
      isLoading={isLoading}
      gridTitle={getLocalizedString("exclusions")}
      helpItems={helpItems}
      rowData={exclusions}
      menuItems={[createButton, editButton, deleteButton, duplicateButton]}
      columnDefPage={COLUMN_PATHS.exclusions}
      hasExpand
      hasHelp
    >
      {
        state.formIsOpen &&
        <ExclusionsFormDialog
          open={state.formIsOpen}
          data={state.selectedItem}
          moduleList={moduleList}
          tree={tree}
          collaboratorsList={collaboratorsList}
          isLoading={isLoading}
          submitCallback={state.selectedItem ? handlers.handleUpdate : handlers.handleCreate}
          handleClose={handlers.handleCloseForm}
        />
      }
      {
        state.duplicateFormIsOpen &&
        <DuplicateExclusionsFormDialog
          open={state.duplicateFormIsOpen}
          data={state.selectedItem}
          moduleList={moduleList}
          tree={tree}
          collaboratorsList={collaboratorsList}
          isLoading={isLoading}
          submitCallback={handlers.handleDuplicate}
          handleClose={handlers.handleCloseDuplicateForm}
        />
      }
    </CommonPage>
  )
}

export default Exclusions;